import React, { FC, MouseEventHandler } from 'react'

interface Props {
  label: string
  count: number
  icon?: string
  onChange?: (updated: number) => void
  allowNegative?: boolean
}

const PassengerLuggageCounter: FC<Props> = ({ label, icon, onChange, count, allowNegative = false }) => {
  const decrement: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()

    if (allowNegative || count > 0) {
      onChange?.(count - 1)
    }
  }

  const increment: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault()
    onChange?.(count + 1)
  }

  return (
    <div className="ps-row d-flex align-items-center py-2">
      <span className="ps-row-icon">{!!icon && <span className={`icon-${icon}`}></span>}</span>
      <span className="flex-grow-1 pl-2">{label}</span>
      <div className="ps-row-ctrls d-flex align-items-center">
        <button
          type="button"
          className={`${!allowNegative && count === 0 ? 'disabled' : ''} text-secondary bg-light-blue p-1 btn btn-link`}
          onClick={decrement}
        >
          <span className="icon-minus"></span>
        </button>
        <span className="px-3 row-item-count text-center">{count}</span>
        <button type="button" className="text-secondary bg-light-blue p-1 btn btn-link" onClick={increment}>
          <span className="icon-plus"></span>
        </button>
      </div>
    </div>
  )
}

export default PassengerLuggageCounter
